module.exports = __webpack_public_path__ + "img/yeux_tests.484d0eea.jpg";